import { gql } from '@apollo/client';

const UPDATE_RESTAURANT = gql`
  mutation updateRestaurant(
    $id: String!
    $fbadTrackId: String
    $gaTrackId: String
    $snapTrackId: String
    $gtmTrackId: String
    $capiAccessToken: String
  ) {
    updateRestaurant(
      id: $id
      fbadTrackId: $fbadTrackId
      gaTrackId: $gaTrackId
      snapTrackId: $snapTrackId
      gtmTrackId: $gtmTrackId
      capiAccessToken: $capiAccessToken
    ) {
      id
      fbadTrackId
      gaTrackId
      snapTrackId
      gtmTrackId
      capiAccessToken
    }
  }
`;

export default UPDATE_RESTAURANT;
